import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useFormik } from 'formik';

import { AppBarWithButtons } from '../../../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppFormDateTimePicker from '../../../../../../components/designe/forms/app-form-date-time-picker';
import AppFormTextField from '../../../../../../components/designe/forms/app-form-text-field';
import { TrainingStatus } from '../../../../../../shared/constants';
import { ITraining } from '../../../../../../types/interfaces/training';
import { useStyles } from './CopyTraining.styles';

interface ICopyTrainingProps {
  training: ITraining;
  onCancel: () => void;
  onCopyTraining: (data: {
    title: string;
    planedStartDate?: Date | null;
  }) => Promise<any>;
}

export default function CopyTraining(props: ICopyTrainingProps) {
  const { onCancel, onCopyTraining, training } = props;
  const [loader, setLoader] = useState<boolean>(false);
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const placeholder = `${training.title}(${t('common.copy')})`;

  const formik = useFormik({
    initialValues: {
      title: '',
      planedStartDate: training?.planedStartDate || null,
    },
    onSubmit: (values) => {
      setLoader(true);
      onCopyTraining({
        title: values.title || placeholder,
        planedStartDate: values.planedStartDate,
      }).finally(() => {
        setLoader(false);
      });
    },
  });

  return (
    <Box className={classes.copyTrainingWrapper}>
      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" flexDirection="column" gap={1}>
          <AppFormTextField
            label={t('common.title')}
            fullWidth
            autoFocus
            name="title"
            formik={formik}
            placeholder={placeholder}
          />

          <AppFormDateTimePicker
            label={t('trainings.planedStartDate')}
            name="planedStartDate"
            formik={formik}
          />
        </Box>

        <Box className={classes.copyTrainingBottom}>
          <AppBarWithButtons
            loading={loader}
            onClick={formik.handleSubmit}
            onCancelClick={onCancel}
          />
        </Box>
      </form>
    </Box>
  );
}
